import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SideRailNav from "./SideRailNav";

const NAV_KEYS = [
  "advantage",
  "services",
  "sprint",
  "principles",
  "reviews",
  "careers",
  "contact",
] as const;

// Ścieżki, na których pasek się nie pokazuje (landing ma własny, CRM ma swoje menu).
const HIDDEN_PREFIXES = ["/crm", "/login", "/reset-password", "/client-portal", "/portal"];

export default function GlobalSideRail() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const hidden = pathname === "/" || HIDDEN_PREFIXES.some((p) => pathname.startsWith(p));

  useEffect(() => {
    if (hidden) return;
    document.body.classList.add("lg:pl-[62px]");
    return () => document.body.classList.remove("lg:pl-[62px]");
  }, [hidden]);

  if (hidden) return null;

  return (
    <SideRailNav
      items={NAV_KEYS.map((key) => ({ key, href: `/#${key}`, label: t(`nav.${key}`) }))}
      activeKey={pathname.startsWith("/insights") ? "insights" : null}
      expanded={expanded}
      onMouseEnter={() => setExpanded(true)}
      onMouseLeave={() => setExpanded(false)}
      onNavigate={(key) => navigate(`/#${key}`)}
      rpoLabel={t("nav.rpo")}
      insightsLabel={t("nav.insights")}
    />
  );
}
